import Disclaimer from '../../components/disclaimer';
import GridItem from '../../components/grid-item';
import { useWindowResizeEffect } from '../../hooks/resizeHeight';
import useDesktopCheck from '../../hooks/useDesktopCheck';
import Layout from '../../Layout';
import { Helmet } from 'react-helmet';

const title = 'Caraiman – gust echilibrat, numai bun să-ți tragi sufletul ';
const description =
  'Descoperă rețeta naturală a berii Caraiman cu gust echilibrat, inspirat de liniștea muntelui, ca să-ți tragi sufletul oricând simți nevoia de o pauză.';

const PromotionRules = () => {
  const height = useWindowResizeEffect();
  const isDesktop = useDesktopCheck();
  const promotionItems = [
  	{
      title: 'REGULAMENT CONCURS GRATAR DE 1 MAI',
      description: '27 aprilie 2026 - 01 mai 2026',
      action: '/pdfs/Caraiman_Regulament_Campanie_Facebook_Instagram_27.04_final.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING BUCUREȘTI',
      description: '15 aprilie 2026 - 31 mai 2026',
      action: '/pdfs/RegulamentBucuresti202604.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING GIURGIU',
      description: '15 aprilie 2026 - 31 mai 2026',
      action: '/pdfs/RegulamentGiurgiu202604.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING TELEORMAN',
      description: '15 aprilie 2026 - 31 mai 2026',
      action: '/pdfs/RegulamentTeleorman202604.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING ARGEȘ',
      description: '06 aprilie 2026 - 30 aprilie 2026',
      action: '/pdfs/ScanCaraimanArges2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING GORJ',
      description: '25 martie 2026 - 30 aprilie 2026',
      action: '/pdfs/ScanCaraiman3-Gorj2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING VALCEA',
      description: '24 martie 2026 - 30 aprilie 2026',
      action: '/pdfs/ScanCaraiman1-Valcea2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING HARGHITA',
      description: '24 martie 2026 - 30 aprilie 2026',
      action: '/pdfs/ScanCaraiman2-Harghita2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING ALBA',
      description: '09 martie 2026 - 30 aprilie 2026',
      action: '/pdfs/ScanCaraiman1-Alba2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING SIBIU',
      description: '09 martie 2026 - 30 aprilie 2026',
      action: '/pdfs/ScanCaraiman2-Sibiu2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING ARAD',
      description: '09 martie 2026 - 30 aprilie 2026',
      action: '/pdfs/ScanCaraiman3-Arad2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING BIHOR',
      description: '09 martie 2026 - 30 aprilie 2026',
      action: '/pdfs/ScanCaraiman4-Bihor2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING SATU-MARE',
      description: '04 martie 2026 - 11 aprilie 2026',
      action: '/pdfs/ScanCaraimanSM2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING MARAMURES',
      description: '04 martie 2026 - 11 aprilie 2026',
      action: '/pdfs/ScanCaraimanMM2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING BISTRITA-NASAUD',
      description: '04 martie 2026 - 11 aprilie 2026',
      action: '/pdfs/ScanCaraimanBN2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING IALOMITA',
      description: '25 februarie 2026 - 31 martie 2026',
      action: '/pdfs/RegulamentCaraiman1Ialomita2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING GALATI',
      description: '25 februarie 2026 - 31 martie 2026',
      action: '/pdfs/RegulamentCaraiman2Galati2026.pdf',
    },
    {
      title: 'REGULAMENT SAMPLING VRANCEA',
      description: '25 februarie 2026 - 31 martie 2026',
      action: '/pdfs/RegulamentCaraiman3Vrancea2026.pdf',
    },
    {
      title: 'SAMPLING CARAIMAN DOZA DANIOFAN',
      description: '18 februarie 2026 - 18 martie 2026',
      action: '/pdfs/RegulamentDaniofan2026.pdf',
    },
    {
      title: 'SAMPLING CARAIMAN DOZA LUNOK',
      description: '18 februarie 2026 - 18 martie 2026',
      action: '/pdfs/RegulamentLunok2026.pdf',
    },
    {
      title: 'CAMPANIE PROMOTIONALA CARAIMAN PRESEZON',
      description: '01 martie 2026 - 31 mai 2026',
      action: '/pdfs/RegulamentPresezon2026.pdf',
    },
    {
      title: 'SAMPLING CARAIMAN DOZA SAFEWAY STORES',
      description: '09 februarie 2026 - 27 februarie 2026',
      action: '/pdfs/RegulamentAmplingDozaSafewayStores.pdf',
    },
    {
      title: 'CARAIMAN GIFT ON PACK PET 2,5L',
      description: '01 ianuarie 2026 – 28 februarie 2026',
      action: '/pdfs/RegulamentPETBruschette.pdf',
    },
    {
      title: 'TOMBOLA CARAIMAN ALBA IULIA',
      description: '16 decembrie 2025 – 16 ianuarie 2026',
      action: '/pdfs/RegulamentAlbaIulia.pdf',
    },
    {
      title: 'CONCURS FACEBOOK CARAIMAN',
      description: '12 decembrie 2025 – 19 decembrie 2025',
      action: '/pdfs/RegulamentCampanieFacebook.pdf',
    },
    {
      title: 'TOMBOLA CARAIMAN',
      description: '10 decembrie 2025 – 31 decembrie 2025',
      action: '/pdfs/RegulamentTombola.pdf',
    },
    {
      title: 'SAMPLING CARAIMAN DOZA DANEMAR',
      description: '29 noiembrie 2025 – 05 decembrie 2025',
      action: '/pdfs/RegulamentDanemar.pdf',
    },
    {
      title: 'SAMPLING CARAIMAN DOZA JAM',
      description: '29 noiembrie 2025 – 05 decembrie 2025',
      action: '/pdfs/RegulamentJam.pdf',
    },
    {
      title: 'SAMPLING CARAIMAN DOZA AUTO IMPEX PRIMA',
      description: '29 noiembrie 2025 – 05 decembrie 2025',
      action: '/pdfs/RegulamentAIP.pdf',
    },
    {
      title: 'SAMPLING CARAIMAN DOZA DIANA',
      description: '29 noiembrie 2025 – 05 decembrie 2025',
      action: '/pdfs/RegulamentDiana.pdf',
    },
    {
      title: 'SAMPLING CARAIMAN',
      description: '20 noiembrie – 30 noiembrie 2025',
      action: '/pdfs/RegulamentSamplingCaraiman-20noiembrie.pdf',
    },
    {
      title: 'PROMOȚIA DIN LIDL!',
      description: '29 septembrie – 19 octombrie 2025',
      action: '/pdfs/RegulamentPromotieLidl-29septembrie.pdf',
    },
    {
      title: 'CABANIERUL TE INVITĂ LA #CONCURS!',
      description: '1 septembrie – 7 septembrie 2025',
      action: '/pdfs/RegulamentConcursCaraiman-1septembrie.pdf',
    },
    {
      title: 'PROMOȚIA CU 100.000 DE EURO ȘI BERI SUB CAPAC',
      description: '1 august 2025 - 31 mai 2026',
      action: '/pdfs/RegulamentNCPCaraiman-1august2025.pdf',
    },
    {
      title: 'COMPLETEAZĂ TALONUL ȘI POȚI CÂȘTIGA UN PREMIU',
      description: '1 martie 2025 - 31 mai 2025',
      action: '/pdfs/RegulamentDualCorePremii1martie.pdf',
    },
    {
      title: 'RĂZUIEȘTE TALONUL ȘI  POȚI CÂȘTIGA O DOZĂ DE 0,5L',
      description: '1 martie 2025 - 31 mai 2025',
      action: '/pdfs/RegulamentDozaOFFTrade1martie.pdf',
    },
    {
      title: 'RĂZUIEȘTE TALONUL ȘI POȚI CÂȘTIGA O STICLĂ DE 0,5L',
      description: '1 martie 2025 - 31 mai 2025',
      action: '/pdfs/RegulamentSticlaOFFTrade1martie.pdf',
    },
    {
      title: 'CAMPANIE PET 2,5L CU DOZĂ 0,5L CADOU',
      description: '1 ian - 28 feb 2025',
      action: '/pdfs/RegulamentNCPCaraiman-1ian2025.pdf',
    },
    {
      title: 'PROMOȚIA CU BERI SUB CAPAC ȘI BANI SĂ-ȚI FACI O CABANĂ',
      description: '1 aug 2024 - 31 mai 2025',
      action: '/pdfs/RegulamentNCPCaraiman-1aug2024.pdf',
    },
  ];

  const handleGridItemClick = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Layout>
      <Helmet>
        <title>Regulamentul promotiei | {title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
      </Helmet>
      <div
        style={{
          minHeight: height + 20,
          backgroundImage: isDesktop
            ? "url('/images/regulament-promotie/cabana_desktop.png')"
            : "url('/images/regulament-promotie/cabana_mobile.png')",
        }}
        className="flex flex-col lg:flex-row items-center lg:items-start flex-grow bg-secondary-grey pt-16 lg:pt-20 w-full bg-no-repeat bg-right-bottom"
      >
        <div className="flex flex-col items-center lg:items-start lg:min-w-max px-8 lg:p-10">
          <h1 className="font-extrabold text-center lg:text-left text-3xl mt-8 text-primary-green">
            {isDesktop ? (
              <>
                PE SCURT. TOTUL ÎNCEPE CU
                <br />
                TRAS SUFLETUL LA UN
                <br />
                CARAIMAN RECE. DAR CA SĂ ȘTII
                <br />
                PRECIS CUM POȚI SĂ CÂȘTIGI.
                <br />
                ȚI-AM PUS TOATE DETALIILE AICI.
              </>
            ) : (
              'PE SCURT. TOTUL ÎNCEPE CU TRAS SUFLETUL LA UN CARAIMAN RECE. DAR CA SĂ ȘTII PRECIS CUM POȚI SĂ CÂȘTIGI. ȚI-AM PUS TOATE DETALIILE AICI.'
            )}
          </h1>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 p-5 lg:p-10 mb-5 lg:mb-0">
          {/* Generate grid items */}
          {promotionItems.map((item, index) => (
            <GridItem
              key={index}
              title={item.title}
              description={item.description}
              onClick={() => handleGridItemClick(item.action)}
            />
          ))}
        </div>
        <Disclaimer
          image="/images/icons-green.png"
          textColor="text-primary-green"
        />
      </div>
    </Layout>
  );
};

export default PromotionRules;
